import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


const initialState: { salaryDeleteIds: number[], isReset: boolean, employeeId: number[] } = { salaryDeleteIds: [], isReset: false, employeeId:[] }

const SalarySlice = createSlice({
    name: 'Salary',
    initialState,
    reducers: {
        SET_SALARY_DELETE_IDS(state, action: PayloadAction<any>) {
            state.salaryDeleteIds = action.payload
            state.isReset = false
        },
        RESET_SALARY_ID(state, action: PayloadAction<any>) {
            state.salaryDeleteIds = action.payload
            state.isReset = true
        },
        SET_EMPLOYEE_IDS(state, action: PayloadAction<any>){
            state.employeeId =action.payload
            state.isReset=false
        }
    },
})

export const { SET_SALARY_DELETE_IDS, RESET_SALARY_ID, SET_EMPLOYEE_IDS } = SalarySlice.actions
export default SalarySlice.reducer